/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService, UNPLACEHOLDER } from '@dm/core';
import { LifProtoCol } from 'app/common/constants';
import { ProductConfig } from 'app/config/switch';

const convertObj = (obj: any): any => Object.keys(obj).map((key) => [key, obj[key]]);

/**
 * 提供所有组件的Detail详情
 */
@Injectable({
    providedIn: 'root',
})
export class SourceEnumService {
    enumMap;
    LUN;
    LUNGROUP;
    Namespace;
    NamespaceGROUP;
    HOST;
    PORTGROUP;
    LOGICPORT;
    LUNSNAPSHOT;
    FILESYSTEM;
    TENANT;
    keys = ['LUN', 'LUNGROUP', 'Namespace', 'NamespaceGROUP', 'HOST', 'PORTGROUP', 'LOGICPORT', 'LUNSNAPSHOT', 'FILESYSTEM', 'TENANT'];

    constructor(public i18n: I18nService) {
        const get = this.i18n.get;
        this.LUN = {
            HEALTHSTATUS: {
                1: get('common.EnumDefine_RUNNING_STATUS_E_NORMAL'),
                2: get('common.EnumDefine_RUNNING_STATUS_E_ERROR'),
                15: get('common.EnumDefine_HEALTH_STATUS_E_WRITE_PROTECT'),
            },
            HEALTHSTATUS_COLOR: {
                1: '#7ADFA0',
                2: '#F45C5E',
                15: 'gray',
            },
            RUNNINGSTATUS: {
                27: get('common.EnumDefine_RUNNING_STATUS_E_ONLINE'),
                28: get('common.EnumDefine_RUNNING_STATUS_E_OFFLINE'),
            },
            RUNNINGSTATUS_COLOR: {
                27: '#7ADFA0',
                28: '#F45C5E',
            },
            WRITEPOLICY: {
                1: get('storage.lun_task_create_writeBack_label'),
                2: get('storage.lun_task_create_writeThrough_label'),
            },
            functionType: {
                1: get('common.objectType_LUN'),
                2: get('common.snapshots'),
                3: get('common.clone_button'),
            },
            mapped: {
                false: get('common.mapping_unMapped_value'),
                true: get('common.mapping_mapped_value'),
            },
        };
        this.LUNGROUP = {
            ISADD2MAPPINGVIEW: {
                true: get('common.mapping_mapped_value'),
                false: get('common.mapping_unMapped_value'),
            },
        };
        this.Namespace = {
            HEALTHSTATUS: {
                1: get('common.EnumDefine_RUNNING_STATUS_E_NORMAL'),
                2: get('common.EnumDefine_RUNNING_STATUS_E_ERROR'),
                15: get('common.EnumDefine_HEALTH_STATUS_E_WRITE_PROTECT'),
            },
            HEALTHSTATUS_COLOR: {
                1: '#7ADFA0',
                2: '#F45C5E',
                15: 'gray',
            },
            RUNNINGSTATUS: {
                27: get('common.EnumDefine_RUNNING_STATUS_E_ONLINE'),
                28: get('common.EnumDefine_RUNNING_STATUS_E_OFFLINE'),
            },
            RUNNINGSTATUS_COLOR: {
                27: '#7ADFA0',
                28: '#F45C5E',
            },
            WRITEPOLICY: {
                1: get('storage.lun_task_create_writeBack_label'),
                2: get('storage.lun_task_create_writeThrough_label'),
            },
            functionType: {
                1: get('common.objectType_LUN'),
                2: get('common.snapshots'),
                3: get('common.clone_button'),
            },
            EXPOSEDTOINITIATOR: {
                false: get('common.mapping_unMapped_value'),
                true: get('common.mapping_mapped_value'),
            },
        };
        this.NamespaceGROUP = {
            ISADD2MAPPINGVIEW: {
                true: get('common.mapping_mapped_value'),
                false: get('common.mapping_unMapped_value'),
            },
        };
        this.HOST = {
            HEALTHSTATUS: {
                1: get('common.EnumDefine_STATUS_E_NORMAL'),
                2: get('common.EnumDefine_HEALTH_STATUS_E_NO_REDUNDANT_LINK'),
                17: get('common.EnumDefine_HEALTH_STATUS_E_NO_REDUNDANT_LINK'),
                18: get('common.EnumDefine_RUNNING_STATUS_E_OFFLINE'),
            },
            OPERATIONSYSTEM: {
                0: get('common.EnumDefine_OS_TYPE_E_LINUX'),
                1: get('common.EnumDefine_OS_TYPE_E_WINDOWS'),
                2: get('common.EnumDefine_OS_TYPE_E_SOLARIS'),
                3: get('common.EnumDefine_OS_TYPE_E_HPUX'),
                4: get('common.EnumDefine_OS_TYPE_E_AIX'),
                5: get('common.EnumDefine_OS_TYPE_E_XenServer'),
                6: get('common.EnumDefine_OS_TYPE_E_MACOS'),
                7: get('common.EnumDefine_OS_TYPE_E_ESX'),
                8: get('common.EnumDefine_OS_TYPE_E_LINUXVIS'),
                9: get('common.EnumDefine_OS_TYPE_E_WINDOWS'),
                10: get('common.EnumDefine_OS_TYPE_E_Oracle_VM_Server_for_x86'),
                11: get('common.EnumDefine_OS_TYPE_E_OpenVMS'),
                12: get('common.EnumDefine_OS_TYPE_E_Oracle_VM_Server_for_x86'),
                13: get('common.EnumDefine_OS_TYPE_E_Oracle_VM_Server_for_SPARC'),
            },
            accessMode: {
                0: get('protection.protectionGroup_task_createHyper_hostAccessMode_balance'),
                1: get('protection.protectionGroup_task_createHyper_hostAccessMode_asymmetric'),
            },
        };
        this.PORTGROUP = {
            isAddToMappingView: {
                true: get('common.mapping_mapped_value'),
                false: get('common.mapping_unMapped_value'),
            },
            portType: {
                0: get('common.EnumDefine_MOTYPE_PHYSICAL_PORT'),
                1: get('common.EnumDefine_MOTYPE_LOGICAL_PORT'),
                16: UNPLACEHOLDER,
            },
        };
        this.LOGICPORT = {
            RUNNINGSTATUS: {
                0: get('common.EnumDefine_HEALTH_STATUS_E_UNKNOWN'),
                1: get('common.EnumDefine_RUNNING_STATUS_E_NORMAL'),
                2: get('common.EnumDefine_RUNNING_STATUS_E_RUNNING'),
                10: get('common.EnumDefine_RUNNING_STATUS_E_LINK_UP'),
                11: get('common.EnumDefine_RUNNING_STATUS_E_LINK_DOWN'),
                33: get('common.EnumDefine_RUNNING_STATUS_E_TO_BE_RECOVERD'),
                53: get('common.EnumDefine_RUNNING_STATUS_INITIALIZING'),
                110: get('common.EnumDefine_RUNNING_STATUS_E_TO_BE_WORK'),
            },
            OPERATIONALSTATUS: {
                true: get('common.EnumDefine_RUNNING_STATUS_E_ACTIVATED'),
                false: get('common.EnumDefine_RUNNING_STATUS_E_UNACTIVATED'),
            },
            SUPPORTPROTOCOL: {
                0: get('common.term_confirm_none'),
                1: get('common.NFS_lab'),
                2: get('common.CIFS_lab'),
                3: get('NFS + CIFS'),
                4: get('iSCSI'),
                8: get('FC/FCoE'),
                64: get('common.NVMeoF_RoCE_lab'),
                512: get('common.BGP_lab'),
                [LifProtoCol.DataTurbo]: get('common.DataTurbo_lab'),
                ...(ProductConfig.isSupportS3Protocol ? {
                    [LifProtoCol.S3]: get('service.Cloudtier_task_remoteIPGroup_create_S3_value'),
                } : {}),
            },
        };
        this.LUNSNAPSHOT = {
            HEALTHSTATUS: {
                1: get('common.EnumDefine_RUNNING_STATUS_E_NORMAL'),
                2: get('common.EnumDefine_RUNNING_STATUS_E_ERROR'),
                15: get('common.EnumDefine_HEALTH_STATUS_E_WRITE_PROTECT'),
            },
            RUNNINGSTATUS: {
                0: get('common.EnumDefine_RUNNING_STATUS_E_UNKNOWN'),
                43: get('common.EnumDefine_RUNNING_STATUS_E_ACTIVATED'),
                44: get('common.EnumDefine_RUNNING_STATUS_E_ROLLBACK'),
                45: get('common.EnumDefine_RUNNING_STATUS_E_INACTIVATED'),
                53: get('common.EnumDefine_RUNNING_STATUS_INITIALIZING'),
                106: get('common.EnumDefine_RUNNING_STATUS_REMOVING'),
            },
            RUNNINGSTATUS_COLOR: {
                0: '#7ADFA0',
                43: '#F45C5E',
                44: '#F45C5E',
                45: '#F45C5E',
                53: '#F45C5E',
                106: '#F45C5E',
            },
        };
        this.FILESYSTEM = {
            HEALTHSTATUS: {
                1: get('common.EnumDefine_RUNNING_STATUS_E_NORMAL'),
                2: get('common.EnumDefine_RUNNING_STATUS_E_ERROR'),
                14: get('common.EnumDefine_HEALTH_STATUS_E_INVALID'),
                15: get('common.EnumDefine_HEALTH_STATUS_E_WRITE_PROTECT'),
            },
            RUNNINGSTATUS: {
                27: get('common.EnumDefine_RUNNING_STATUS_E_ONLINE'),
                28: get('common.EnumDefine_RUNNING_STATUS_E_OFFLINE'),
                35: get('common.EnumDefine_RUNNING_STATUS_E_INVALID'),
                53: get('common.EnumDefine_RUNNING_STATUS_INITIALIZING'),
            },
        };
        this.TENANT = {
            RUNNINGSTATUS: {
                1: get('common.EnumDefine_RUNNING_STATUS_E_NORMAL'),
                53: get('common.EnumDefine_RUNNING_STATUS_INITIALIZING'),
            },
            isPair: {
                false: get('common.term_No_label'),
                true: get('common.term_yes_label'),
            },
        };
        const enumMap = new Map();
        this.keys.forEach((key) => {
            const map = new Map(convertObj(this[key]));
            enumMap.set(key, map);
        });
        this.enumMap = enumMap;
    }

    // 取出对应的枚举映射
    get(type: string, key: string): string {
        return this.enumMap.get(type).get(key);
    }
}
